{
    "NAME": "CallRecIntegration",
    "AddCallRecIntegrationTitle": "Integratie gespreksopname toevoegen",
    "ModifyCallRecIntegrationTitle": "Call Recording Integratie Aanpassen",
    "TabGeneralTitle": "Algemeen",
    "TabScopeAssignmentsTitle": "Reikwijdte Toewijzingen",
    "TabApiCommunicationsTitle": "Api communicatie",
    "TabDubberCommunicationsTitle": "Dubber communicatie",
    "IdentifierGUID": "Identifier (GUID):",
    "IdentifierGUIDPlaceholder": "[Auto Toegewezen]",
    "IntegrationType": "Type integratie:",
    "IntegrationType_1": "[Onbekend of niet gespecificeerd type]",
    "IntegrationType_2": "Dubber Corporation Limited",
    "ModifyCallRecIntegrationDescriptionFormLabel": "Beschrijving:",
    "DubberApiComSettingsLocationUrls": "Dubber Locatie URL:",
    "ApiComSettingsIPAddrOne": "IP-adres 1 (MAIN):",
    "ApiComSettingsIPAddrTwo": "IP-adres 2 (SECONDARY):",
    "ApiComSettingsAuthDetailsMainTitle": "Authenticatiegegevens (HOOFD)",
    "ApiComSettingsAuthDetailsMainUserName": "Gebruikersnaam (HOOFD):",
    "ApiComSettingsAuthDetailsMainUserPassword": "Wachtwoord (HOOFD):",
    "ApiComSettingsAuthDetailsSecondaryTitle": "Authenticatiegegevens (SECONDARY):",
    "ApiComSettingsAuthDetailsSecondaryUserName": "Gebruikersnaam (secundair):",
    "ApiComSettingsAuthDetailsSecondaryUserPassword": "Wachtwoord (secundair):",
    "ApiComSettingsApiParamOne": "API Parameter 1:",
    "ApiComSettingsApiParamTwo": "API Parameter 2:",
    "DubberComSettingsApiParamOne": "Rekeningnaam (TRAILING DEEL):",
    "DubberComSettingsApiParamTWO": "Accountgebruiker \/ E-MAIL (OPTIONEEL):",
    "DubberComSettingsTitle": "Dubber communicatie-instellingen",
    "DubberComSettingsLocationURL": "Dubber Locatie URL:",
    "DubberComSettingsDevAuthTitle": "Authenticatie ontwikkelaar",
    "DubberComSettingsDevAuthUserName": "Gebruikersnaam (MASHERYID KEY):",
    "DubberComSettingsDevAuthUserPassword": "Wachtwoord (MASHERYID SECRET):",
    "DubberComSettingsAccountApiAuthTitle": "Account-API-authenticatie",
    "DubberComSettingsAccountApiAuthUserName": "Gebruikersnaam (API AUTH ID):",
    "DubberComSettingsAccountApiAuthUserPassword": "Wachtwoord (API AUTH TOKEN):",
    "DubberComSettingAccountName": "Rekeningnaam (achterliggend deel)",
    "DubberComSettingsAccountUserEmail": "Accountgebruiker \/ e-mail (optioneel)",
    "CallRecIntegrationAddModify_UnknownOrDeleted": "[Onbekend of Verwijderd]",
    "CallRecIntegrationAddModify_ServerErrorTitle": "Validatiefouten",
    "CallRecIntegrationAddModify_ValidationWarning": "Zorg ervoor dat alle velden correct zijn ingevuld",
    "CallRecIntegrationAddModify_ButtonHelpLabel": "Helpen?",
    "CallRecIntegrationAddModify_ButtonSubmitLabel": "Sla",
    "CallRecIntegrationAddModify_ButtonCancelLabel": "Annuleren",
    "CallRecIntegrationAddModify_PromptMessage": "Weet je zeker dat je dit venster wilt sluiten? Alle gewijzigde configuraties gaan verloren bij het sluiten.",
    "CallRecIntegrationAddModify_PromptConfirm": "Ja",
    "CallRecIntegrationAddModify_PromptCancel": "Annuleren",
    "Error_TestIntegration_Timeout": "Aanmelden voor testintegratie is uitgetimed",
    "InputField_Change_Username": "[Gebruikersnaam wijzigen].",
    "InputField_Change_Password": "[Wachtwoord wijzigen].",
    "DubberComSettings_Parameters": "Parameters",
    "DubberComSettings_TestIntegrationAuth": "Testintegratie-authenticatie",
    "DubberSuccessfullIntegration": "De communicatie-instellingen voor de integratie van oproepopnamen werken succesvol"
}